import TUIEmojiPlugin from './components/index.vue';
import server from './server/index';
server.getInstance();
export { TUIEmojiPlugin };
